import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './PaymentFailed.css';

const PaymentFailed = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { appointmentId, errorMessage, appointmentData, doctorFee, totalFee, selectedDoctor } = state || {};

  const handleRetryPayment = () => {
    navigate('/review-appointment', {
      state: { appointmentData, doctorFee, totalFee, selectedDoctor },
    });
  };

  const handleCancelBooking = () => {
    const patientUser = JSON.parse(localStorage.getItem('patientUser'));
    navigate(`/patient-dashboard/${patientUser.id}`);
  };

  if (!appointmentId) {
    return (
      <div className="payment-failed">
        <h2>Error</h2>
        <p>Invalid payment data. Please try again.</p>
        <button onClick={() => navigate('/review-appointment')}>Go Back</button>
      </div>
    );
  }

  return (
    <div className="payment-failed">
      <h2>Payment Failed</h2>
      <p><strong>Reason:</strong> {errorMessage || 'Payment was not completed. Please try again or refresh the page.'}</p>
      <p><strong>Appointment ID:</strong> {appointmentId}</p>
      <div className="failure-options">
        <button onClick={handleRetryPayment}>Retry Payment</button>
        <button onClick={handleCancelBooking}>Cancel and Return to Dashboard</button>
      </div>
    </div>
  );
};

export default PaymentFailed;